




























import { defineComponent, ref, useContext } from '@nuxtjs/composition-api'
import { ProductReference } from '@/types/product/productTypes'
import { filterReferencesForBackground, generateReferenceUrl } from '@/common/utils/product/product'
import { usePdpStore } from '~/store/pdp'
import { usePDPNavigationObserver } from '~/composables/pdp/usePDPNavigationObserver'
import { COMPONENTS_IN_NAVIGATION } from '@/common/utils/product/constants'

export default defineComponent({
  props: {
    productBackground: {
      type: String,
      required: false,
      default: undefined,
    },
    references: {
      type: Array as () => Array<ProductReference>,
      required: false,
      default: undefined,
    },
  },
  setup(props) {
    const ctx = useContext()
    const isPreviewServer = ctx.$config.cst.isPreview

    let mappedReferences: any[] = []
    if (props.references) {
      mappedReferences = filterReferencesForBackground(props.references)
    }

    const pdpStore = usePdpStore()
    const backgroundRef = usePDPNavigationObserver(() => {
      pdpStore.setActiveComponentInNavigation(COMPONENTS_IN_NAVIGATION.BACKGROUND.ANCHOR)
    })

    const displayCondition = ref(!!props.productBackground || !!mappedReferences.length)
    if (displayCondition.value) {
      pdpStore.setComponentAsRendered(COMPONENTS_IN_NAVIGATION.BACKGROUND)
    }

    return { displayCondition, mappedReferences, generateReferenceUrl, backgroundRef, isPreviewServer }
  },
})
